import { APICore } from "./apiCore";

const api = new APICore();

// Get all devices
function getDevicesApi(params?: { page?: number; limit?: number; type?: string; status?: string }) {
  const baseUrl = "/web/boxes";
  return api.get(`${baseUrl}`, params || {});
}

// Update a device
function updateDeviceApi(params: {
  id: string;
  unique_id: string;
  device_id: string;
  name: string;
  location_id: number | string | null;
  corporate_id: number | string | null;
  total_powerbanks: number;
  available_powerbanks: number;
  status: string;
}) {
  const baseUrl = "/web/boxes";
  return api.updatePatch(`${baseUrl}/${params.id}`, params);
}

// Add a new device
function addDeviceApi(params: {
  unique_id: string;
  device_id: string;
  name: string;
  location_id: number | string | null;
  corporate_id: number | string | null;
  total_powerbanks: number;
  available_powerbanks: number;
}) {
  const baseUrl = "/web/boxes";
  return api.create(`${baseUrl}`, params);
}

// Delete a device
function deleteDeviceApi(params: { id: string }) {
  const baseUrl = "/web/boxes";
  return api.delete(`${baseUrl}/${params.id}`);
}

// Update device availability
function updateDeviceAvailabilityApi(params: { id: string; available_powerbanks: number }) {
  const baseUrl = "/web/boxes-availability";
  return api.updatePatch(`${baseUrl}/${params.id}`, params);
}

export { getDevicesApi, updateDeviceApi, addDeviceApi, deleteDeviceApi, updateDeviceAvailabilityApi };
